import './header.css';
import logoImg from '../../img/logos/white logo.png'
import {Link} from "react-router-dom";

function Header (){
    return (
        <header className='header position-fixed width-100'>
            <div className="container">
                <div className="header__row">
                    <div className="header__logo">
                        <Link to="/" className="header__logo">
                            <img src={logoImg} alt="logo" />
                            <span>Airlink</span>
                        </Link>
                    </div>
                    <nav className="header__nav">
                        <ul>
                            <li><a href='/'>Головна</a></li>
                            <li><a href="mailto:airlinklviv@gmail.com">Консультація</a></li>
                            <li>
                                {" "}
                                <Link to="Order" className="header__nav-btn">Купити</Link>
                            </li>
                        </ul>

                    </nav>
                </div>
            </div>
        </header>
    )
}

export default Header;